import { render } from "./WalletElement.vue?vue&type=template&id=4d0b9b3a"
import script from "./WalletElement.vue?vue&type=script&lang=js"
export * from "./WalletElement.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__